import { React, Component } from 'utils';
import './galleryslider.less'

export default class GallerySlider extends Component {

	constructor(props)
	{
		super(props);

		var count = props.stand.standPhotos.length;

		this.state = {
			active: 0,
			previous: count,
			count: count,
			slideshow: true
		}
	}

	componentDidMount() {
		this.timer = setInterval(this.changeSlide, 2000);
	}

	componentWillUnmount() {
		clearTimeout(this.timer);
	}

	changeSlide = () => {
		var { slideshow, active, count } = this.state;

		if(slideshow) {

			var previous = active;
			active++;

			if(active >= count) {
				active = 0;
			}

			this.setState({ active, previous });
		}
	}

	handleMouseEnter = () => {
		this.setState({ slideshow: false });
	}

	handleMouseLeave = () => {
		this.setState({ slideshow: true });
	}

	render() {

		var { data, stand } = this.props;
		var { active, previous } = this.state;

		var photos = stand.standPhotos;

		var slides = photos.map((item, index) => {

			var css = ['slide', 'photo-' + item.id];

			if(active == index || previous == index) {
				css.push('active');
			}

			if(previous == index) {
				css.push('previous');
			}

			var style = {
				backgroundImage: 'url(' + item.imageUrl + ')'
			}

			return <div key={ item.id } className={ css.join(' ') } style={ style }>

			</div>
		});

		return <div className="slider" onMouseEnter={ this.handleMouseEnter } onMouseLeave={ this.handleMouseLeave }>
			<div className="slides">{ slides }</div>
		</div>

	}

}


// WEBPACK FOOTER //
// ./src/modules/components/galleryslider.js